// Centralized app configuration with fallback defaults.
// Values are read from environment variables first; if not present, fallbacks are used.

const config = {
  SERVER_BASE_URL:
    process.env.REACT_APP_SERVER_BASE_URL ||
    "https://api-dev.peekup.app/api/v1",

  MAP_CENTER_LAT:
    +(process.env.REACT_APP_MAP_CENTER_LAT) || 14.634624437853013,

  MAP_CENTER_LNG:
    +(process.env.REACT_APP_MAP_CENTER_LNG) || 121.03432457373226,

  GOOGLE_API_KEY:
    process.env.REACT_APP_GOOGLE_API_KEY ||
    "AIzaSyCLpEtCOohIDtBXSf0KPwTTS4dgfZH7F6M",

  FLEET_ENGINE_PROJECT_ID:
    process.env.REACT_APP_FLEET_ENGINE_PROJECT_ID || "peekup-testing",

  SOCKET_URL:
    process.env.REACT_APP_SOCKET_URL || "wss://dev.websocket.peekup.app",

  MQTT_BROKER:
    process.env.REACT_APP_MQTT_BROKER || "mqtt.dev.pay.peekup.app",

  MQTT_TOPIC:
    process.env.REACT_APP_MQTT_TOPIC || "admin/driver-location-tracking",

  MQTT_PORT:
    +(process.env.REACT_APP_MQTT_PORT) || 443,

  MQTT_USERNAME:
    process.env.REACT_APP_MQTT_USERNAME || "peekup-admin",

  MQTT_PASSWORD:
    process.env.REACT_APP_MQTT_PASSWORD || "peekup@mqtt11",

  WEBSOCKET_SERVER_BASE_URL:
    process.env.REACT_APP_WEBSOCKET_SERVER_BASE_URL ||
    "wss://dev.websocket.peekup.app",
};

export default config;
